export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4656.6521f2e4.jpg";